    (() => {
  const TEST_ID = "MMI31";
  const VARIANT_ID = "V4";
  const PRODUCT_HANDLE = window.__MMI31_PRODUCT_HANDLE || "";

  function logInfo(message) {
    console.log(
      `%cAcadia%c${TEST_ID}-${VARIANT_ID}`,
      "color: white; background: rgb(122, 122, 211); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
      "margin-left: 8px; color: white; background: rgb(0, 57, 57); font-weight: 700; padding: 2px 4px; border-radius: 2px;",
      message,
    );
  }
  logInfo("fired");
  function waitForElem(
    waitFor,
    callback,
    minElements = 1,
    isVariable = false,
    timer = 10000,
    frequency = 25
  ) {
    let elements = isVariable
      ? window[waitFor]
      : document.querySelectorAll(waitFor);
    if (timer <= 0) return;
    (!isVariable && elements.length >= minElements) ||
      (isVariable && typeof window[waitFor] !== "undefined")
      ? callback(elements)
      : setTimeout(
        () =>
          waitForElem(
            waitFor,
            callback,
            minElements,
            isVariable,
            timer - frequency
          ),
        frequency
      );
  }

  function poll(t, i, o = !1, e = 1e4, a = 25) { e < 0 || (t() ? i() : setTimeout(() => { poll(t, i, o, o ? e : e - a, a) }, a)) }

  const IMAGES = {
    "mental-performance-shot-original": {
      desktop: "https://cdn.shopify.com/s/files/1/0251/9524/9748/files/Hand-Gradient_FREE_2_2.png?v=1781725836",
      mobile: "https://cdn.shopify.com/s/files/1/0612/5086/3345/files/mmi31-hand-holding-bottle-v4-mbl.png?v=1774257561",
      mode: "firstSlide",
    },
    "mental-performance-shot-maxx": {
      desktop: "https://cdn.shopify.com/s/files/1/0251/9524/9748/files/Hand-Gradient_FREE_2_3.png?v=1781725894",
      mobile: "https://cdn.shopify.com/s/files/1/0251/9524/9748/files/Hand-Gradient_FREE_2_3.png?v=1781725894",
      mode: "firstSlide",
    },
    "mental-performance-shot-free": {
      desktop: "https://cdn.shopify.com/s/files/1/0251/9524/9748/files/Hand-Gradient_FREE_2_mbl.png?v=1780948780",
      mobile: "https://cdn.shopify.com/s/files/1/0251/9524/9748/files/Hand-Gradient_FREE_2_mbl.png?v=1780948780",
      mode: "firstSlide",
    },
    "magic-mind-welcome-sleep-melatonin": {
      desktop: "https://cdn.shopify.com/s/files/1/0251/9524/9748/files/Magic_Mind_with_Melly.png?v=1782155418",
      mobile: "https://cdn.shopify.com/s/files/1/0251/9524/9748/files/Magic_Mind_with_Melly.png?v=1782155418",
      mode: "firstSlide",
    },
  };

  // https://cdn.shopify.com/s/files/1/0251/9524/9748/files/Hand-Gradient_FREE_2.png?v=1780680300
  const config = IMAGES[PRODUCT_HANDLE];
  if (!config) return;

  function replacePicture(picture, desktopUrl, mobileUrl) {
    if (!picture || !desktopUrl) return;
    const mobile = mobileUrl || desktopUrl;
    const img = picture.querySelector("img");
    const source = picture.querySelector("source");
    if (img) {
      img.src = desktopUrl;
      img.srcset = desktopUrl;
    }
    if (source) source.srcset = mobile;
  }

  function replaceImgNode(img, url) {
    if (!img || !url) return;
    img.src = url;
    img.srcset = url;
  }

  function refreshSwipers() {
    const galleryEl = document.querySelector(".main-product-v2__gallery");
    const thumbsEl = document.querySelector(".main-product-v2__thumbnails");
    galleryEl?.swiper?.update?.();
    thumbsEl?.swiper?.update?.();
  }

  function getFirstGallerySlide() {
    return document.querySelector(
      ".main-product-v2__gallery-wrapper > .main-product-v2__gallery-slide"
    );
  }

  function getFirstThumbSlide() {
    return document.querySelector(
      ".main-product-v2__thumbnails-wrapper > .main-product-v2__thumbnails-slide"
    );
  }

  function replaceFirstSlideImages(gallerySlide, thumbSlide, desktopUrl, mobileUrl) {
    if (!gallerySlide) return false;

    replacePicture(gallerySlide.querySelector("picture"), desktopUrl, mobileUrl);

    const thumbUrl = mobileUrl || desktopUrl;
    thumbSlide
      ?.querySelectorAll("img:not(.main-product-v2__sticker)")
      .forEach((img) => {
        replaceImgNode(img, thumbUrl);
      });

    return true;
  }

  function replaceFirstSlide(desktopUrl, mobileUrl) {
    return replaceFirstSlideImages(
      getFirstGallerySlide(),
      getFirstThumbSlide(),
      desktopUrl,
      mobileUrl
    );
  }

  function replaceFirstSlideAfterSwiper(desktopUrl, mobileUrl) {
    const thumbUrl = mobileUrl || desktopUrl;

    document
      .querySelectorAll('.main-product-v2__gallery [data-swiper-slide-index="0"]')
      .forEach((slide) => {
        replacePicture(slide.querySelector("picture"), desktopUrl, mobileUrl);
      });

    document
      .querySelectorAll(
        '.main-product-v2__thumbnails-wrapper [data-swiper-slide-index="0"] img'
      )
      .forEach((img) => {
        replaceImgNode(img, thumbUrl);
      });

    fixThumbsLoopIfNeeded();
    refreshSwipers();
    return true;
  }

  function fixThumbsLoopIfNeeded() {
    const thumbsEl = document.querySelector(".main-product-v2__thumbnails");
    const swiper = thumbsEl?.swiper;
    if (!swiper?.params?.loop) return;

    const realCount = thumbsEl.querySelectorAll(
      ".main-product-v2__thumbnails-slide:not(.swiper-slide-duplicate)"
    ).length;
    const perView =
      typeof swiper.params.slidesPerView === "number" ? swiper.params.slidesPerView : 7;

    if (realCount >= perView) return;

    if (typeof swiper.loopDestroy === "function") {
      swiper.loopDestroy(true, true);
    }
    swiper.params.loop = false;
    swiper.update();
  }

  function replaceByAlt(altMap) {
    const gallerySlide = getFirstGallerySlide();
    const thumbSlide = getFirstThumbSlide();
    if (!gallerySlide) return false;

    let replaced = 0;

    Object.entries(altMap).forEach(([altText, url]) => {
      gallerySlide.querySelectorAll("picture").forEach((picture) => {
        const img = picture.querySelector("img");
        if (!img || (img.getAttribute("alt") || "").trim() !== altText) return;
        replacePicture(picture, url, url);
        replaced += 1;
      });

      if (thumbSlide) {
        thumbSlide.querySelectorAll("img").forEach((img) => {
          if ((img.getAttribute("alt") || "").trim() !== altText) return;
          replaceImgNode(img, url);
          replaced += 1;
        });
      }
    });

    return replaced > 0;
  }

  function replaceByAltAfterSwiper(altMap) {
    const gallerySlides = document.querySelectorAll(
      '.main-product-v2__gallery [data-swiper-slide-index="0"]'
    );
    const thumbSlides = document.querySelectorAll(
      '.main-product-v2__thumbnails-wrapper [data-swiper-slide-index="0"]'
    );
    if (!gallerySlides.length) return false;

    let replaced = 0;

    Object.entries(altMap).forEach(([altText, url]) => {
      gallerySlides.forEach((gallerySlide) => {
        gallerySlide.querySelectorAll("picture").forEach((picture) => {
          const img = picture.querySelector("img");
          if (!img || (img.getAttribute("alt") || "").trim() !== altText) return;
          replacePicture(picture, url, url);
          replaced += 1;
        });
      });

      thumbSlides.forEach((slide) => {
        slide.querySelectorAll("img").forEach((img) => {
          if ((img.getAttribute("alt") || "").trim() !== altText) return;
          replaceImgNode(img, url);
          replaced += 1;
        });
      });
    });

    if (replaced > 0) {
      fixThumbsLoopIfNeeded();
      refreshSwipers();
    }
    return replaced > 0;
  }

  function isGalleryReady() {
    return !!document.querySelector(".main-product-v2__gallery img");
  }

  function isBeforeSwiperInit() {
    const thumbs = document.querySelector(".main-product-v2__thumbnails");
    return (
      !!getFirstThumbSlide()?.querySelector("img") &&
      !thumbs?.classList.contains("swiper-initialized")
    );
  }

  function isAfterSwiperInit() {
    return !!document.querySelector('[data-swiper-slide-index="0"] img');
  }

  function applyReplacements() {
    if (config.mode === "firstSlide") {
      return replaceFirstSlide(config.desktop, config.mobile);
    }
    if (config.mode === "byAlt") {
      return replaceByAlt(config.alts);
    }
    return false;
  }

  function applyReplacementsAfterSwiper() {
    if (config.mode === "firstSlide") {
      return replaceFirstSlideAfterSwiper(config.desktop, config.mobile);
    }
    if (config.mode === "byAlt") {
      return replaceByAltAfterSwiper(config.alts);
    }
    return false;
  }

  function isByAltReadyBeforeSwiper() {
    const slide0 = getFirstGallerySlide();
    return slide0 && slide0.querySelectorAll("picture img[alt]").length >= 2;
  }

  function mainJs() {
    let applied = false;
    let loopFixed = false;

    poll(
      () => {
        if (applied) return true;
        if (!isGalleryReady()) return false;

        if (isBeforeSwiperInit()) {
          if (config.mode === "byAlt" && !isByAltReadyBeforeSwiper()) return false;
          return true;
        }

        if (isAfterSwiperInit()) {
          if (config.mode === "byAlt") {
            const slide0 = document.querySelector(
              '.main-product-v2__gallery [data-swiper-slide-index="0"]'
            );
            if (!slide0 || slide0.querySelectorAll("picture img[alt]").length < 2) {
              return false;
            }
          }
          return true;
        }

        return false;
      },
      () => {
        if (applied) return;

        if (isBeforeSwiperInit()) {
          applied = applyReplacements();
          if (applied) logInfo(`applied before swiper for ${PRODUCT_HANDLE}`);
          return;
        }

        applied = applyReplacementsAfterSwiper();
        if (applied) logInfo(`applied after swiper for ${PRODUCT_HANDLE}`);
      }
    );

    poll(
      () => {
        if (loopFixed) return true;
        return document
          .querySelector(".main-product-v2__thumbnails")
          ?.classList.contains("swiper-initialized");
      },
      () => {
        if (loopFixed) return;
        fixThumbsLoopIfNeeded();
        refreshSwipers();
        loopFixed = true;
        logInfo(`thumbs loop checked for ${PRODUCT_HANDLE}`);
      }
    );
  }

  waitForElem("body", mainJs);
})();
